import type {
    ThreadsClientInterface,
    ThreadsGetParams,
    ThreadCountsParams,
    ThreadsPriorityParams,
    AssignPayload,
    SnoozePayload,
} from './threadsClient.types';
import BaseClient, { type BaseClientConfig, type ExtendedAxiosRequestConfig } from '../BaseClient';

export default class GroupThreadsClient extends BaseClient implements ThreadsClientInterface {
    constructor(private teamId: number, private groupId: string, config: BaseClientConfig = {}) {
        super(config);
    }

    getThreads(params?: ThreadsGetParams, config?: ExtendedAxiosRequestConfig) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/threads`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getSummary(config?: ExtendedAxiosRequestConfig) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/threads/summary`;
        return this.makeCoreApiRequest(url, 'get', null, undefined, config);
    }

    getCounts(params?: ThreadCountsParams, config?: ExtendedAxiosRequestConfig) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/threads/counts`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getPriority(params?: ThreadsPriorityParams, config?: ExtendedAxiosRequestConfig) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/threads/priority`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    setState(contactId: number, state: string) {
        const action = state === 'open' ? 'open' : 'close';
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/contacts/${contactId}/thread/${action}`;
        return this.makeCoreApiRequest(url, 'post');
    }

    snooze(contactId: number, payload: SnoozePayload) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/contacts/${contactId}/thread/snooze`;
        return this.makeCoreApiRequest(url, 'post', payload);
    }

    complete(contactId: number) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/contacts/${contactId}/thread/complete`;
        return this.makeCoreApiRequest(url, 'post');
    }

    assignToSelf(contactId: number) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/contacts/${contactId}/thread/claim`;
        return this.makeCoreApiRequest(url, 'post');
    }

    assignTo(contactId: number, payload: AssignPayload) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/contacts/${contactId}/thread/assign`;
        return this.makeCoreApiRequest(url, 'post', payload);
    }

    unclaim(contactId: number) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/contacts/${contactId}/thread/unclaim`;
        return this.makeCoreApiRequest(url, 'post');
    }

    checkpointSave(contactId: number) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/contacts/${contactId}/thread/checkpoint`;
        return this.makeCoreApiRequest(url, 'post');
    }

    checkpointDelete(contactId: number) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/contacts/${contactId}/thread/checkpoint`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    checkpointGet(contactId: number) {
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${this.groupId}/contacts/${contactId}/thread/checkpoint`;
        return this.makeCoreApiRequest(url, 'get');
    }
}
